<template>
  <div>
    <div class="row">
      <div v-if="tipo == 'trimovil'" class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label><b>TRIMOVIL</b></label>
          <selectDetalleTrimovil
            :valor_entrada="registroPrincipal.iddetalle_trimovil"
            @evento="
              registroPrincipal.iddetalle_trimovil = $event;
              getTrimovilReductor();
            "
            v-model="registroPrincipal.iddetalle_trimovil"
          />
        </div>
      </div>
      <div v-if="tipo == 'trimovil' || tipo == 'glp'" class="col-xl-4 col-lg-4">
        <div class="form-group text-center">
          <label><b>Boleta Informativa</b></label> <br />
          <label for="no">
            <input
              id="no"
              type="radio"
              value="0"
              v-validate="'required'"
              name="boleta_informativa"
              v-model="registroPrincipal.boleta_informativa"
            />
            NO</label
          >
          &nbsp;
          <label for="si">
            <input
              id="si"
              type="radio"
              value="1"
              name="boleta_informativa"
              v-validate="'required'"
              v-model="registroPrincipal.boleta_informativa"
            />
            SI </label
          ><br />
          <error :attribute_name="'boleta_informativa'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'glp'" class="col-xl-4 col-lg-4">
        <div class="form-group text-center">
          <label><b>Ingeniero Firmante</b></label> <br />
          
          <select v-model="registroPrincipal.idinge"   v-validate="'required'"
              name="ingeniero"  class="form-control">
              <option value="">Seleccione..</option>
            <option  v-for="inge in ingenieros"
              :key="inge.Id"
              :value="inge.Id">{{ inge.apellidos_nombres }}</option>
            </select>        
          <error :attribute_name="'ingeniero'" :errors_form="errors" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-2 col-lg-2">
        <div class="form-group">
          <label><b>Certificado N° </b></label>
          <input
            v-show="
              (tipo != 'glp' && tipo != 'gnv' && tipo != 'modificacion') ||
              this.$store.state.usuario.idtipo == 2
            "
            type="text"
            data-vv-name="certificado"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.certificado"
            placeholder="Ingrese el Nro certificado"
            class="form-control font-weight-bold"
          />
          <input
            v-show="
              (tipo == 'glp' && !this.nuevo) ||
              (tipo == 'gnv' && !this.nuevo) ||
              (tipo == 'modificacion' && !this.nuevo)
            "
            type="text"
            disabled
            data-vv-name="certificado"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.certificado"
            placeholder="Ingrese el Nro certificado"
            class="form-control font-weight-bold"
          />
          <select
            v-show="
              (tipo == 'glp' && this.nuevo) ||
              (tipo == 'glp' && this.duplicar) ||
              (tipo == 'modificacion' && this.nuevo) ||
              (tipo == 'modificacion' && this.duplicar) ||
              (tipo == 'gnv' && this.nuevo) ||
              (tipo == 'gnv' && this.duplicar)
            "
            disabled
            data-vv-name="certificado"
            v-validate="'required'"
            v-model="registroPrincipal.certificado"
            name="certificadosAsignados"
            style="font-size: 20px"
            class="text-center p-0 form-control font-weight-bold"
          >
            <option
              v-for="cer in certificadosAsignados"
              :key="cer"
              :value="cer"
            >
              {{ cer }}
            </option>
          </select>
          <error :attribute_name="'certificado'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo != 'modificacion'" class="col-xl-2 col-lg-2">
        <div class="form-group">
          <label><b>Celular</b></label>
          <input
            type="text"
            data-vv-name="celular"
            maxlength="9"
            v-validate="'required'"
            v-model="registroPrincipal.cel"
            placeholder="Ingrese el celular"
            class="form-control font-weight-bold"
          />
          <error :attribute_name="'celular'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-2 col-lg-2">
        <div class="form-group">
          <label><b>Fec. Emisión</b></label>
          <input
            type="date"
            data-vv-name="fecha_Emision"
            @keyup="getFechaExpiracion()"
            @change="getFechaExpiracion()"
            v-validate="'required'"
            v-model="registroPrincipal.fecha_registro"
            class="form-control font-weight-bold text-center"
          />
          <error :attribute_name="'fecha_Emision'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-2 col-lg-2">
        <div class="form-group">
          <label><b>Fec. Vencimiento</b></label>
          <input
            type="date"
            data-vv-name="fecha_Vencimiento"
            v-validate="'required'"
            v-model="registroPrincipal.fecha_expiracion"
            class="form-control font-weight-bold text-center"
          />
          <error :attribute_name="'fecha_Vencimiento'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-2 col-lg-2">
        <div class="form-group">
          <label><b>Fec. Creación Registro</b></label>
          <input
            type="datetime"
            disabled
            v-model="registroPrincipal.fecha_add"
            class="form-control font-weight-bold text-center"
          />
        </div>
      </div>
      <div class="col-xl-2 col-lg-2">
        <div class="form-group">
          <label><b>Fec. Actualización Registro</b></label>
          <input
            type="datetime"
            disabled
            v-model="registroPrincipal.fecha_update"
            class="form-control font-weight-bold text-center"
          />
        </div>
      </div>
      <div
        v-if="tipo != 'gnv'"
        :class="{
          'col-xl-6 col-lg-6': tipo == 'modificacion',
          'col-xl-8 col-lg-8': tipo != 'modificacion',
        }"
      >
        <div class="form-group">
          <label>Propietario</label>
          <input
            type="text"
            data-vv-name="propietario"
            v-validate="'required'"
            v-model="registroPrincipal.propietario"
            placeholder="Ingrese el propietario"
            class="form-control"
          />
          <error :attribute_name="'propietario'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-2 col-lg-2">
        <div class="form-group">
          <label>Construido para</label>
          <select
            v-model="registroPrincipal.idtipo_rectificacion"
            data-vv-name="construido"
            v-validate="'required'"
            class="form-control"
          >
            <option value="">Seleccione..</option>
            <option value="1">PERSONAS</option>
            <option value="2">MERCANCIAS</option>
          </select>
          <error :attribute_name="'construido'" :errors_form="errors" />
        </div>
      </div>
      <div
        class="col-xl-4 col-lg-4"
        :class="{ 'col-xl-6 col-lg-6': tipo == 'gnv' }"
      >
        <div class="form-group">
          <label>Ciudad</label>
          <locales
            v-if="this.$store.state.usuario.idtipo == 2"
            :valor_entrada="registroPrincipal.idciudad"
            v-model="registroPrincipal.idciudad"
            @evento="registroPrincipal.idciudad = $event"
            data-vv-name="ciudad"
            v-validate="'required'"
          />
          <select
            v-if="
              (tipo == 'glp' && this.$store.state.usuario.idtipo == 1) ||
              (tipo == 'modificacion' &&
                this.$store.state.usuario.idtipo == 1) ||
              (tipo == 'gnv' && this.$store.state.usuario.idtipo == 1)
            "
            v-model="registroPrincipal.idciudad"
            data-vv-name="ciudad"
            v-validate="'required'"
            class="form-control"
          >
            <option
              v-for="loc in locales"
              :value="loc.idlocal"
              :key="loc.idlocal"
            >
              {{ loc.vendedor }}
            </option>
          </select>
          <error :attribute_name="'ciudad'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Placa Rodaje</label>
          <input
            type="text"
            data-vv-name="placa_rodaje"
            v-validate="'required'"
            v-model="registroPrincipal.placa_rodaje"
            placeholder="Ingrese la placa de rodaje"
            class="form-control"
          />
          <error :attribute_name="'placa_rodaje'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Carroceria</label>
          <input
            type="text"
            data-vv-name="carrorecia"
            v-validate="'required'"
            v-model="registroPrincipal.carroceria"
            placeholder="Ingrese carroceria"
            class="form-control"
          />
          <error :attribute_name="'carrorecia'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Categoría</label>
          <input
            type="text"
            :disabled="tipo == 'trimovil'"
            data-vv-name="categoria"
            v-validate="'required'"
            v-model="registroPrincipal.categoria"
            placeholder="Ingrese la categoria"
            class="form-control"
          />
          <error :attribute_name="'categoria'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Marca</label>
          <input
            type="text"
            :disabled="tipo == 'trimovil'"
            data-vv-name="marca"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.marca"
            placeholder="Ingrese la marca"
            class="form-control"
          />
          <error :attribute_name="'marca'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Modelo</label>
          <input
            type="text"
            :disabled="tipo == 'trimovil'"
            data-vv-name="modelo"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.modelo"
            placeholder="Ingrese el modelo"
            class="form-control"
          />
          <error :attribute_name="'modelo'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Clase</label>
          <input
            type="text"
            maxlength="50"
            v-model="registroPrincipal.clase"
            placeholder="Ingrese clase"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Versión</label>
          <input
            type="text"
            :disabled="tipo == 'trimovil'"
            data-vv-name="version"
            v-validate="'required'"
            v-model="registroPrincipal.version"
            placeholder="Ingrese version"
            class="form-control"
          />
          <error :attribute_name="'version'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Año de Fabricación</label>
          <input
            type="text"
            maxlength="4"
            v-model="registroPrincipal.anio_fabrica"
            placeholder="Ingrese el año de fabricación"
            class="form-control"
          />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Año Modelo</label>
          <input
            type="text"
            data-vv-name="año_modelo"
            maxlength="4"
            v-validate="'required'"
            v-model="registroPrincipal.anio_modelo"
            placeholder="Ingrese el año de fabricación"
            class="form-control"
          />
          <error :attribute_name="'año_modelo'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Combustible</label>
          <input
            type="text"
            data-vv-name="combustible"
            v-validate="'required'"
            v-model="registroPrincipal.combustible"
            placeholder="Ingrese el combustible"
            class="form-control"
          />
          <error :attribute_name="'combustible'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo != 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>VIN/N° de Serie</label>
          <input
            type="text"
            data-vv-name="nro_serie"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.vin_nro_serie"
            placeholder="Ingrese el VIN/N° de Serie"
            class="form-control"
          />
          <error :attribute_name="'nro_serie'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>VIN</label>
          <input
            type="text"
            maxlength="50"
            v-model="registroPrincipal.vin"
            placeholder="Ingrese el VIN/N° de Serie"
            class="form-control"
          />
          <!-- <error :attribute_name="'nro_serie'" :errors_form="errors" /> -->
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Serie</label>
          <input
            type="text"
            data-vv-name="serie"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.nro_serie"
            placeholder="Ingrese el N° de Serie"
            class="form-control"
          />
          <error :attribute_name="'serie'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>N° de Motor</label>

          <input
            type="text"
            data-vv-name="nro_motor"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.nro_motor"
            placeholder="Ingrese el N° de Motor"
            class="form-control"
          />
          <error :attribute_name="'nro_motor'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo != 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>N° Cilindros/Cilindrada</label>
          <input
            v-if="tipo != 'trimovil'"
            type="text"
            data-vv-name="nro_cilindros"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.cilindrada"
            placeholder="Ingrese el N° de cilindros"
            class="form-control"
          />
          <selectTrimovil
            v-if="tipo == 'trimovil'"
            data-vv-name="nro_cilindros"
            maxlength="50"
            v-validate="'required'"
            :marca="registroPrincipal.iddetalle_trimovil"
            :tipo="'nro_cilindro'"
            v-model="registroPrincipal.cilindrada"
            :valor_entrada="registroPrincipal.cilindrada"
            @evento="registroPrincipal.cilindrada = $event"
          />
          <error :attribute_name="'nro_cilindros'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Cilindros</label>
          <input
            type="text"
            data-vv-name="nro_cilindros"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.cilindros"
            placeholder="Ingrese el N° de cilindros"
            class="form-control"
          />

          <error :attribute_name="'nro_cilindros'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Cilindrada</label>
          <input
            type="text"
            data-vv-name="cilindrada"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.cilindrada"
            placeholder="Ingrese cilindrada"
            class="form-control"
          />

          <error :attribute_name="'cilindrada'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo != 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Combustible</label>
          <tipo_combustible
            v-model="registroPrincipal.combustible"
            @evento="registroPrincipal.combustible = $event"
            data-vv-name="combustible"
            v-validate="'required'"
            :valor_entrada="registroPrincipal.combustible"
            :tipo="tipo"
          />
          <!-- <input type="text" data-vv-name="combustible" maxlength="50" v-validate="'required'"
                        v-model="registroPrincipal.combustible" placeholder="Ingrese el combustible"
                        class="form-control">-->
          <error :attribute_name="'combustible'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo != 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>N° Ejes/N° Ruedas</label>
          <input
            type="text"
            :disabled="tipo == 'trimovil'"
            data-vv-name="nro_ruedas"
            maxlength="30"
            v-validate="'required'"
            v-model="registroPrincipal.ejes_ruedas"
            placeholder="Ingrese el N° Ejes/N° Ruedas"
            class="form-control"
          />
          <error :attribute_name="'nro_ruedas'" :errors_form="errors" />
        </div>
      </div>
      <div
        v-if="tipo == 'modificacion' || tipo == 'gnv'"
        class="col-xl-3 col-lg-4"
      >
        <div class="form-group">
          <label>Colores</label>
          <input
            type="text"
            data-vv-name="colores"
            maxlength="80"
            v-validate="'required'"
            v-model="registroPrincipal.colores"
            placeholder="Ingrese colores"
            class="form-control"
          />
          <error :attribute_name="'colores'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Potencia</label>
          <input
            type="text"
            data-vv-name="potencia"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.potencia"
            placeholder="Ingrese potencia"
            class="form-control"
          />
          <error :attribute_name="'potencia'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Formula Rodante</label>
          <input
            type="text"
            data-vv-name="formula_rodante"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.formula_rodante"
            placeholder="Ingrese formula rodante"
            class="form-control"
          />
          <error :attribute_name="'formula_rodante'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Ruedas</label>
          <input
            type="text"
            data-vv-name="ruedas"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.ruedas"
            placeholder="Ingrese ruedas"
            class="form-control"
          />
          <error :attribute_name="'ruedas'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>N° Ejes</label>
          <input
            type="text"
            data-vv-name="ruedas"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.nro_ejes"
            placeholder="Ingrese ruedas"
            class="form-control"
          />
          <error :attribute_name="'ruedas'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Asientos</label>
          <input
            type="text"
            data-vv-name="asientos"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.asientos"
            placeholder="Ingrese asientos"
            class="form-control"
          />
          <error :attribute_name="'asientos'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Pasajeros</label>
          <input
            type="text"
            data-vv-name="pasajeros"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.pasajeros"
            placeholder="Ingrese pasajeros"
            class="form-control"
          />
          <error :attribute_name="'pasajeros'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Peso seco</label>
          <input
            type="text"
            data-vv-name="peso_seco"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.peso_seco"
            placeholder="Ingrese peso seco"
            class="form-control"
          />
          <error :attribute_name="'peso_seco'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Peso bruto</label>
          <input
            type="text"
            data-vv-name="peso_bruto"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.peso_bruto"
            placeholder="Ingrese peso bruto"
            class="form-control"
          />
          <error :attribute_name="'peso_bruto'" :errors_form="errors" />
        </div>
      </div>

      <div v-if="tipo != 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>N° Asientos/Pasajeros</label>
          <input
            v-if="tipo != 'trimovil'"
            type="text"
            data-vv-name="nro_asientos"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.asientos_pasajeros"
            placeholder="Ingrese el N° Asientos/Pasajeros"
            class="form-control"
          />
          <selectTrimovil
            v-if="tipo == 'trimovil'"
            data-vv-name="nro_asientos"
            maxlength="50"
            v-validate="'required'"
            :marca="registroPrincipal.iddetalle_trimovil"
            :tipo="'asientos_pasajeros'"
            v-model="registroPrincipal.asientos_pasajeros"
            :valor_entrada="registroPrincipal.asientos_pasajeros"
            @evento="registroPrincipal.asientos_pasajeros = $event"
          />
          <error :attribute_name="'nro_asientos'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo != 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Largo / Ancho / Alto</label>
          <input
            v-if="tipo != 'trimovil'"
            type="text"
            data-vv-name="largo_ancho_alto"
            maxlength="30"
            v-validate="'required'"
            v-model="registroPrincipal.largo_ancho_alto"
            placeholder="Ingrese el Largo / Ancho / Alto"
            class="form-control"
          />
          <selectTrimovil
            v-if="tipo == 'trimovil'"
            data-vv-name="largo_ancho_alto"
            maxlength="50"
            v-validate="'required'"
            :marca="registroPrincipal.iddetalle_trimovil"
            :tipo="'largo_ancho_alto'"
            v-model="registroPrincipal.largo_ancho_alto"
            :valor_entrada="registroPrincipal.largo_ancho_alto"
            @evento="registroPrincipal.largo_ancho_alto = $event"
          />
          <error :attribute_name="'largo_ancho_alto'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo != 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Peso Neto</label>
          <input
            v-if="tipo != 'trimovil'"
            type="text"
            data-vv-name="peso_neto"
            @keyup="getNuevoPeso()"
            maxlength="50"
            v-validate="'required|decimal:3'"
            v-model="registroPrincipal.peso_neto"
            placeholder="Ingrese el peso neto"
            class="form-control"
          />
          <selectTrimovil
            v-if="tipo == 'trimovil'"
            data-vv-name="peso_neto"
            maxlength="50"
            v-validate="'required'"
            :marca="registroPrincipal.iddetalle_trimovil"
            :tipo="'peso_neto'"
            v-model="registroPrincipal.peso_neto"
            :valor_entrada="registroPrincipal.peso_neto"
            @evento="
              registroPrincipal.peso_neto = $event;
              getNuevoPeso();
            "
          />
          <error :attribute_name="'peso_neto'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo != 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Peso Bruto Vehicular</label>
          <input
            v-if="tipo != 'trimovil'"
            type="text"
            data-vv-name="peso_bruto"
            maxlength="50"
            v-validate="'required|decimal:3'"
            v-model="registroPrincipal.peso_bruto"
            placeholder="Ingrese el peso bruto"
            class="form-control"
          />
          <selectTrimovil
            v-if="tipo == 'trimovil'"
            data-vv-name="peso_bruto"
            maxlength="50"
            v-validate="'required'"
            :marca="registroPrincipal.iddetalle_trimovil"
            :tipo="'peso_bruto'"
            v-model="registroPrincipal.peso_bruto"
            :valor_entrada="registroPrincipal.peso_bruto"
            @evento="
              registroPrincipal.peso_bruto = $event;
              getNuevoPeso();
            "
          />
          <error :attribute_name="'peso_bruto'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Longitud</label>
          <input
            type="text"
            data-vv-name="longitud"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.longitud"
            placeholder="Ingrese la longitud"
            class="form-control"
          />
          <error :attribute_name="'longitud'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Altura</label>
          <input
            type="text"
            data-vv-name="altura"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.altura"
            placeholder="Ingrese la altura"
            class="form-control"
          />
          <error :attribute_name="'altura'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'modificacion'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Ancho</label>
          <input
            type="text"
            data-vv-name="ancho"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.ancho"
            placeholder="Ingrese la ancho"
            class="form-control"
          />
          <error :attribute_name="'ancho'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo != 'gnv'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Carga Útil</label>
          <input
            v-if="tipo == 'modificacion'"
            type="text"
            data-vv-name="carga_util"
            @keyup="getNuevoPeso()"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.carga_util"
            placeholder="Ingrese la carga util"
            class="form-control"
          />
          <input
            v-if="tipo == 'glp'"
            type="text"
            data-vv-name="carga_util"
            @keyup="getNuevoPeso()"
            maxlength="50"
            v-validate="'required|decimal:3'"
            v-model="registroPrincipal.carga_util"
            placeholder="Ingrese la carga util"
            class="form-control"
          />
          <selectTrimovil
            v-if="tipo == 'trimovil'"
            data-vv-name="carga_util"
            maxlength="50"
            v-validate="'required'"
            :marca="registroPrincipal.iddetalle_trimovil"
            :tipo="'carga_util'"
            :valor_entrada="registroPrincipal.carga_util"
            v-model="registroPrincipal.carga_util"
            @evento="
              registroPrincipal.carga_util = $event;
              getNuevoPeso();
            "
          />
          <error :attribute_name="'carga_util'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'glp' || tipo == 'gnv'" class="col-xl-3 col-lg-4">
        <div class="form-group">
          <label>Taller Autorizado</label>
          <input
            type="text"
            data-vv-name="taller"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.Taller_Autorizado"
            placeholder="Ingrese el nombre del Taller"
            class="form-control"
          />
          <error :attribute_name="'taller'" :errors_form="errors" />
        </div>
      </div>
    </div>
    <div v-if="tipo != 'modificacion'" class="row">
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Reductor Marca</label>
          <input
            type="text"
            :disabled="tipo == 'trimovil'"
            data-vv-name="reductor_marca"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.reductor_marca"
            placeholder="Ingrese la marca del reductor"
            class="form-control font-weight-bold"
          />
          <error :attribute_name="'reductor_marca'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Reductor Modelo</label>
          <input
            type="text"
            :disabled="tipo == 'trimovil'"
            data-vv-name="reductor_modelo"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.reductor_modelo"
            placeholder="Ingrese el modelo del reductor"
            class="form-control font-weight-bold"
          />
          <error :attribute_name="'reductor_modelo'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Reductor N° Serie</label>
          <input
            type="text"
            :disabled="tipo == 'trimovil'"
            data-vv-name="reductor_serie"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.reductor_nro_serie"
            placeholder="Ingrese el Nro de serie del reductor"
            class="form-control font-weight-bold"
          />
          <error :attribute_name="'reductor_serie'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Cilíndrico Marca</label>
          <input
            type="text"
            :disabled="tipo == 'trimovil'"
            data-vv-name="cilindrico_marca"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.cilindro_marca"
            placeholder="Ingrese la marca del cilíndrico"
            class="form-control font-weight-bold"
          />
          <error :attribute_name="'cilindrico_marca'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Cilíndrico Modelo</label>
          <input
            type="text"
            :disabled="tipo == 'trimovil'"
            data-vv-name="cilindrico_modelo"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.cilindro_modelo"
            placeholder="Ingrese el modelo del cilíndrico"
            class="form-control font-weight-bold"
          />
          <error :attribute_name="'cilindrico_modelo'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Cilíndrico N° Serie</label>
          <input
            type="text"
            :disabled="tipo == 'trimovil'"
            data-vv-name="cilindrico_serie"
            maxlength="50"
            v-validate="'required'"
            v-model="registroPrincipal.cilindro_nro_serie"
            placeholder="Ingrese el nro de serie del cilíndrico"
            class="form-control font-weight-bold"
          />
          <error :attribute_name="'cilindrico_serie'" :errors_form="errors" />
        </div>
      </div>
    </div>
    <div v-if="tipo == 'modificacion'" class="row">
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Modificación</label>

          <textarea
            v-model="registroPrincipal.modificacion"
            placeholder="Ingrese modificación"
            class="form-control"
          ></textarea>
          <!-- <error :attribute_name="'modificacion'" :errors_form="errors" /> -->
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Incorporación</label>
          <textarea
            v-model="registroPrincipal.incorporacion"
            placeholder="Ingrese incorporación"
            class="form-control"
          ></textarea>
          <!-- <error :attribute_name="'incorporacion'" :errors_form="errors" /> -->
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Rectificación</label>
          <textarea
            v-model="registroPrincipal.rectificacion"
            placeholder="Ingrese rectificación"
            class="form-control"
          ></textarea>
          <!-- <error :attribute_name="'rectificacion'" :errors_form="errors" /> -->
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Adecuación</label>
          <textarea
            v-model="registroPrincipal.adecuacion"
            placeholder="Ingrese adecuación"
            class="form-control"
          ></textarea>
          <!-- <error :attribute_name="'adecuacion'" :errors_form="errors" /> -->
        </div>
      </div>
    </div>

    <div
      v-if="tipo == 'glp' || tipo == 'gnv' || tipo == 'trimovil'"
      class="row"
    >
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Combustible Nuevo</label>
          <tipo_combustible
            v-model="registroPrincipal.combustible_new"
            @evento="
              registroPrincipal.combustible_new = $event;
              getNuevoPeso();
            "
            data-vv-name="combustible_nuevo"
            v-validate="'required'"
            :valor_entrada="registroPrincipal.combustible_new"
            :tipo="tipo"
          />
          <error :attribute_name="'combustible_nuevo'" :errors_form="errors" />
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Peso Neto Nuevo (kg)</label>
          <input
            type="text"
            data-vv-name="peso_neto_nuevo"
            maxlength="15"
            v-validate="'required'"
            v-model="registroPrincipal.peso_neto_new"
            placeholder="Ingrese el peso neto nuevo"
            class="form-control font-weight-bold text-center"
          />
          <error :attribute_name="'peso_neto_nuevo'" :errors_form="errors" />
        </div>
      </div>
      <div v-if="tipo == 'glp' || tipo == 'trimovil'" class="col-xl-4 col-lg-4">
        <div class="form-group">
          <label>Carga Útil Nuevo (kg)</label>
          <input
            type="text"
            data-vv-name="carga_util_nueva"
            maxlength="15"
            v-validate="'required'"
            v-model="registroPrincipal.carga_util_new"
            placeholder="Ingrese la carga útil nueva"
            class="form-control font-weight-bold text-center"
          />
          <error :attribute_name="'carga_util_nueva'" :errors_form="errors" />
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div
        class="offset-xl-8 offset-lg-8 offset-md-8 col-xl-2 col-lg-2 col-md-2 mb-4 text-center"
      >
        <button
          v-if="nuevo && !duplicar"
          type="button"
          @click="validarFormulario('guardar')"
          class="btn btn-indigo border-dark btn-block shadow-sm"
          style="border-radius: 30px"
        >
          <i class="fa fa-save"></i>
          GUARDAR
        </button>
        <button
          v-else-if="!nuevo && duplicar"
          type="button"
          @click="validarFormulario('guardar')"
          class="btn btn-primary btn-block shadow-sm"
          style="border-radius: 30px"
        >
          <i class="fa fa-save"></i>
          GUARDAR DUPLICADO
        </button>

        <button
          v-else
          type="button"
          @click="validarFormulario('actualizar')"
          class="btn btn-info btn-block shadow-sm text-white"
          style="border-radius: 30px"
        >
          <i class="fa fa-save"></i> EDITAR
        </button>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 text-center">
        <button
          type="button"
          @click="$emit('cancelar')"
          class="btn btn-default btn-sm btn-circle border-dark btn-block shadow-sm"
        >
          <i class="fa fa-times"></i> CANCELAR
        </button>
      </div>
    </div>
  </div>
</template>

 

<script>
import error from "../compartidos/Error.vue";
import locales from "../compartidos/SelectLocales.vue";
import tipo_combustible from "../compartidos/SelectCombustible.vue";
import selectDetalleTrimovil from "../compartidos/SelectDetalleTrimovil.vue";
import selectTrimovil from "./SelectTrimovil.vue";
export default {
  name: "Paso1Component",
  props: [
    "registro",
    "nuevo",
    "tipo",
    "url",
    "duplicar",
    "certificadosAsignados",
    "locales",
    "ingenieros"
  ],
  components: {
    error,
    locales,
    tipo_combustible,
    selectDetalleTrimovil,
    selectTrimovil,
  },
  data() {
    return {
      data: [],

      registroPrincipal: {
        boleta_informativa: "",
        iddetalle_trimovil: "",
        Id: "",
        idtipo: "",
        DNI_persona_registro: "",
        cel: "",
        certificado: "",
        propietario: "",
        placa_rodaje: "",
        carroceria: "",
        clase: "",
        anio_modelo: "",
        vin: "",
        nro_serie: "",
        cilindros: "",
        colores: "",
        potencia: "",
        formula_rodante: "",
        ruedas: "",
        nro_ejes: "",
        asientos: "",
        pasajeros: "",
        peso_seco: "",
        longitud: "",
        altura: "",
        ancho: "",
        modificacion: "",
        incorporacion: "",
        rectificacion: "",
        adecuacion: "",
        idtipo_rectificacion: "",
        categoria: "",
        marca: "",
        modelo: "",
        version: "",
        anio_fabrica: "",
        vin_nro_serie: "",
        nro_motor: "",
        cilindrada: "/",
        combustible: "",
        ejes_ruedas: "/",
        asientos_pasajeros: "/",
        largo_ancho_alto: "/ / /",
        peso_neto: "",
        peso_bruto: "",
        carga_util: "",
        reductor_marca: "",
        reductor_modelo: "",
        reductor_nro_serie: "/",
        cilindro_marca: "",
        cilindro_modelo: "",
        cilindro_nro_serie: "/",
        ciudad: "",
        fecha_registro: "",
        fecha_expiracion: "",
        pdf1: "",
        pdf1Archivo: null,
        pdf2: "",
        pdf2Archivo: null,
        codeQR: "",
        fecha_add: "",
        fecha_update: "",
        idciudad: "",
        Taller_Autorizado: "",
        combustible_new: "",
        peso_neto_new: "",
        carga_util_new: "",
        idinge:""
      },
    };
  },
  created() {

    
  },
  mounted() {
    if (this.certificadosAsignados && this.certificadosAsignados.length > 0) {
      this.registroPrincipal.certificado = this.obtenerNumeroFormateado(
        this.certificadosAsignados[0]
      );
    }
    if (!this.nuevo) {
      if (!this.duplicar) {
        this.registroPrincipal = {
          ...this.registro,
        };
      } else {
        this.registroPrincipal = {
          ...this.registro,
        };
        if (
          this.certificadosAsignados &&
          this.certificadosAsignados.length > 0 &&
          this.duplicar
        ) {
          this.registroPrincipal.certificado = this.obtenerNumeroFormateado(
            this.certificadosAsignados[0]
          );
        }
      }
    } else {
      if (this.tipo == "glp") {
        this.registroPrincipal.combustible = "BI-COMBUSTIBLE GLP";
        this.registroPrincipal.Taller_Autorizado = "AUTOMOTORES ELIAS EIRL";
      } else if (this.tipo == "trimovil") {
        this.registroPrincipal.Taller_Autorizado = "AUTOMOTORES ELIAS EIRL";
      } 

      this.registroPrincipal.fecha_add = this.fechaActual(true);
      this.registroPrincipal.fecha_registro = this.fechaActual(true);
      this.getFechaExpiracion();
    }
  },
  methods: {
    obtenerNumeroFormateado(num) {
      return num.toString().padStart(6, "0"); // Completa con ceros hasta 6 dígitos
    },
    validarFormulario(tipo) {
      this.getMayuscula();
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (tipo == "guardar") {
            this.registroPrincipal.DNI_persona_registro =
              this.$store.state.usuario.idpersona;
            this.$emit("guardar", this.registroPrincipal);
          } else {
            this.$emit("actualizar", this.registroPrincipal);
          }
          return;
        }
      });
    },

    getFechaExpiracion() {
      this.registroPrincipal.fecha_expiracion = this.sumarDias(
        this.registroPrincipal.fecha_registro,
        366
      );
    },
    getNuevoPeso() {
      let accion;
      if (this.tipo == "glp") {
        accion = this.$store.state.dataCombustibleTipo.filter((el) => {
          if (
            el.descripcion == this.registroPrincipal.combustible &&
            el.tipo == "GLP"
          ) {
            return el;
          }
        });
      }
      if (this.tipo == "gnv") {
        accion = this.$store.state.dataCombustibleTipo.filter((el) => {
          if (
            el.descripcion == this.registroPrincipal.combustible &&
            el.tipo == "GNV"
          ) {
            return el;
          }
        });
      }
      if (this.tipo == "trimovil") {
        accion = this.$store.state.dataCombustibleTipo.filter((el) => {
          if (
            el.descripcion == this.registroPrincipal.combustible &&
            el.tipo == "TRIMOVIL"
          ) {
            return el;
          }
        });
      }
      if (this.tipo != "modificacion") {
        this.registroPrincipal.peso_neto_new = (
          parseFloat(this.registroPrincipal.peso_neto) +
          parseFloat(accion[0].peso)
        ).toFixed(3);
        this.registroPrincipal.carga_util_new = (
          parseFloat(this.registroPrincipal.carga_util) +
          parseFloat(accion[0].carga)
        ).toFixed(3);
      }
    },
    getMayuscula() {
      this.registroPrincipal.placa_rodaje =
        this.registroPrincipal.placa_rodaje.toUpperCase();
      this.registroPrincipal.categoria =
        this.registroPrincipal.categoria.toUpperCase();
      this.registroPrincipal.marca = this.registroPrincipal.marca.toUpperCase();
      this.registroPrincipal.modelo =
        this.registroPrincipal.modelo.toUpperCase();
      this.registroPrincipal.nro_motor =
        this.registroPrincipal.nro_motor.toUpperCase();
      this.registroPrincipal.cilindrada =
        this.registroPrincipal.cilindrada.toUpperCase();
      this.registroPrincipal.combustible =
        this.registroPrincipal.combustible.toUpperCase();

      if (this.tipo == "trimovil" || this.tipo == "glp" || this.tipo == "gnv") {
        this.registroPrincipal.vin_nro_serie =
          this.registroPrincipal.vin_nro_serie.toUpperCase();
      }
      if (this.tipo == "trimovil" || this.tipo == "glp" || this.tipo == "gnv") {
        this.registroPrincipal.reductor_marca =
          this.registroPrincipal.reductor_marca.toUpperCase();
        this.registroPrincipal.reductor_modelo =
          this.registroPrincipal.reductor_modelo.toUpperCase();
        this.registroPrincipal.reductor_nro_serie =
          this.registroPrincipal.reductor_nro_serie.toUpperCase();
        this.registroPrincipal.cilindro_marca =
          this.registroPrincipal.cilindro_marca.toUpperCase();
        this.registroPrincipal.cilindro_modelo =
          this.registroPrincipal.cilindro_modelo.toUpperCase();
        this.registroPrincipal.cilindro_nro_serie =
          this.registroPrincipal.cilindro_nro_serie.toUpperCase();
      }
      if (
        this.tipo == "glp" ||
        this.tipo == "modificacion" ||
        this.tipo == "trimovil"
      ) {
        this.registroPrincipal.version =
          this.registroPrincipal.version.toUpperCase();
        this.registroPrincipal.propietario =
          this.registroPrincipal.propietario.toUpperCase();
      }

      if (this.tipo == "glp" || this.tipo == "gnv") {
        this.registroPrincipal.combustible_new =
          this.registroPrincipal.combustible_new.toUpperCase();
        this.registroPrincipal.version =
          this.registroPrincipal.version.toUpperCase();
        this.registroPrincipal.vin_nro_serie =
          this.registroPrincipal.vin_nro_serie.toUpperCase();
        this.registroPrincipal.ejes_ruedas =
          this.registroPrincipal.ejes_ruedas.toUpperCase();
        this.registroPrincipal.asientos_pasajeros =
          this.registroPrincipal.asientos_pasajeros.toUpperCase();
        this.registroPrincipal.largo_ancho_alto =
          this.registroPrincipal.largo_ancho_alto.toUpperCase();
        this.registroPrincipal.Taller_Autorizado =
          this.registroPrincipal.Taller_Autorizado.toUpperCase();
      }

      if (this.tipo == "modificacion") {
        this.registroPrincipal.propietario =
          this.registroPrincipal.propietario.toUpperCase();
        this.registroPrincipal.carroceria =
          this.registroPrincipal.carroceria.toUpperCase();
        this.registroPrincipal.clase =
          this.registroPrincipal.clase.toUpperCase();
        this.registroPrincipal.anio_modelo =
          this.registroPrincipal.anio_modelo.toUpperCase();
        this.registroPrincipal.vin = this.registroPrincipal.vin.toUpperCase();
        this.registroPrincipal.nro_serie =
          this.registroPrincipal.nro_serie.toUpperCase();
        this.registroPrincipal.cilindros =
          this.registroPrincipal.cilindros.toUpperCase();
        this.registroPrincipal.colores =
          this.registroPrincipal.colores.toUpperCase();
        this.registroPrincipal.potencia =
          this.registroPrincipal.potencia.toUpperCase();
        this.registroPrincipal.formula_rodante =
          this.registroPrincipal.formula_rodante.toUpperCase();
        this.registroPrincipal.ruedas =
          this.registroPrincipal.ruedas.toUpperCase();
        this.registroPrincipal.nro_ejes =
          this.registroPrincipal.nro_ejes.toUpperCase();
        this.registroPrincipal.asientos =
          this.registroPrincipal.asientos.toUpperCase();
        this.registroPrincipal.pasajeros =
          this.registroPrincipal.pasajeros.toUpperCase();
        this.registroPrincipal.peso_seco =
          this.registroPrincipal.peso_seco.toUpperCase();
        this.registroPrincipal.longitud =
          this.registroPrincipal.longitud.toUpperCase();
        this.registroPrincipal.altura =
          this.registroPrincipal.altura.toUpperCase();
        this.registroPrincipal.ancho =
          this.registroPrincipal.ancho.toUpperCase();
        this.registroPrincipal.modificacion =
          this.registroPrincipal.modificacion.toUpperCase();
        this.registroPrincipal.incorporacion =
          this.registroPrincipal.incorporacion.toUpperCase();
        this.registroPrincipal.rectificacion =
          this.registroPrincipal.rectificacion.toUpperCase();
        this.registroPrincipal.adecuacion =
          this.registroPrincipal.adecuacion.toUpperCase();
        this.registroPrincipal.ciudad =
          this.registroPrincipal.ciudad.toUpperCase();
      }
    },
    getTrimovilReductor() {
      let objeto = this.$store.state.dataDetalleTrimovil.filter((el) => {
        if (el.Id == this.registroPrincipal.iddetalle_trimovil) {
          return el;
        }
      });
      this.registroPrincipal.reductor_marca = objeto[0].marca;
      this.registroPrincipal.reductor_modelo = objeto[0].modelo;
      this.registroPrincipal.reductor_nro_serie = objeto[0].serie;
      this.registroPrincipal.cilindro_marca = objeto[0].marca_;
      this.registroPrincipal.cilindro_modelo = objeto[0].modelo_;
      this.registroPrincipal.cilindro_nro_serie = objeto[0].serie_;

      this.registroPrincipal.categoria = objeto[0].tri_categoria;
      this.registroPrincipal.marca = objeto[0].tri_marca;
      this.registroPrincipal.version = objeto[0].tri_version;
      this.registroPrincipal.modelo = objeto[0].tri_modelo;
      this.registroPrincipal.vin_nro_serie = objeto[0].tri_bin_serie;
      this.registroPrincipal.ejes_ruedas = objeto[0].tri_ejes_ruedas;
      //this.getNuevoPeso();
    },
  },
  watch: {
    registro(newQuestion) {
      this.registroPrincipal = {
        ...newQuestion,
      };
    },
    nuevo(newQuestion) {
      this.nuevo = newQuestion;
    },
    certificadosAsignados(newQuestion) {
      this.certificadosAsignados = newQuestion;
    },
  },
};
</script>